import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { PswChangeModalComponent } from '../psw-change-modal/psw-change-modal.component';

@Component({
  selector: 'app-admin-profile',
  templateUrl: './admin-profile.component.html',
  styleUrls: ['./admin-profile.component.scss']
})
export class AdminProfileComponent implements OnInit {

  public showMenu = false;
  public profileEmail: any;
  constructor(
    private router: Router,
    private auth: AuthService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.profileEmail = localStorage.getItem('user');
  };

  public showPanelUser(): void {
    const changeValue = true;
    this.showMenu = this.showMenu === false ? changeValue : false;
  };

  public goToResetPwd(): void {
    this.router.navigate(['auth/reset-password']);
  };

  public resetPswModal(): void {
    this.dialog.open(PswChangeModalComponent, {
      width: '512px',
      height: '608px',
      disableClose:true,
      panelClass: 'no-Padding'
    });
  };

  public logOut(): void {
    this.auth.logout();
  };
}
